// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ohR2","colMin":"styles_colMin__CACR9"};